import { TableColumnDefinition } from '../table/table-column-definition'

export const SlatHistoryTableColumnDefinitions: TableColumnDefinition[] = [
  {
    columnName: 'template',
    columnWidth: '80px',
    columnTextAlign: 'left',
    header: 'Assessment Type',
    sortDisabled: true,
    columnType: 'truncated-string',
  },
  {
    columnName: 'presentationDate',
    header: 'Assessment Date',
    sortDisabled: true,
    columnType: 'truncated-string',
    columnWidth: '100px',
    columnTextAlign: 'left',
  },
  {
    columnName: 'age',
    columnWidth: '50px',
    columnTextAlign: 'left',
    header: 'Age (Months)',
    sortDisabled: true,
    columnType: 'truncated-string',
  },
  {
    columnName: 'presenterName',
    columnWidth: '120px',
    columnTextAlign: 'left',
    header: 'Data entered by',
    sortDisabled: true,
    columnType: 'truncated-string',
  },
  {
    columnName: 'assessmentStatus',
    columnWidth: '120px',
    columnTextAlign: 'left',
    header: 'Assessment Status',
    sortDisabled: true,
    columnType: 'truncated-string',
  },
  {
    columnName: 'notes',
    columnWidth: '150px',
    columnTextAlign: 'left',
    header: 'Notes',
    sortDisabled: true,
    columnType: 'truncated-string',
  },
  {
    columnName: 'editReport',
    columnWidth: '80px',
    columnTextAlign: 'left',
    header: '',
    sortDisabled: true,
    columnType: 'link',
    linkText: 'Edit details',
    linkKind: 'icon',
    linkColor: 'primary',
    showIcon: true,
  },
  {
    columnName: 'viewReport',
    columnWidth: '80px',
    columnTextAlign: 'left',
    header: '',
    sortDisabled: true,
    columnType: 'link',
    linkText: 'View details',
    linkKind: 'icon',
    linkColor: 'primary',
    showIcon: true,
  },
]
